import { Component, Input, input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-unblock-modal',
  templateUrl: './unblock-modal.component.html',
  styleUrls: ['./unblock-modal.component.css'],
})
export class UnblockModalComponent  implements OnInit {
  @Input() userNickname!: string;
  constructor(
    private modalController: ModalController,
  ) { }

  ngOnInit() {}

  confirm() {
    this.modalController.dismiss({ confirmed: true });
  }

  cancel() {
    this.modalController.dismiss({ confirmed: false });
  }
}
